module.exports = __webpack_public_path__ + "img/fruit-grapefruit-190x100.1f457a63.jpg";